/**
 * Track an event.
 *
 * @param {String} category - Typically the object that was interacted with (e.g. 'Video')
 * @param {String} action - The type of interaction (e.g. 'play')
 * @param {String} label - Useful for categorizing events (e.g. 'Home Page')
 * @param {Number} value - A numeric value associated with the event (e.g. 23)
 * @return {void}
 */
export function trackEvent(category, action, label = null, value = null) {
  if (navigator.doNotTrack === '1') {
    return
  }

  if (typeof window.snowplow === 'function') {
    window.snowplow('trackStructEvent', category, action, label, null, value)
  }

  if (typeof window.ga === 'function') {
    window.ga('send', {
      hitType: 'event',
      eventCategory: category,
      eventAction: action,
      eventLabel: label,
      eventValue: value,
    })
  }
}
